// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  root: { padding: "0px !important" } 
}), { index: 1 });